import React, { useEffect, useState } from 'react';
import type { FC } from 'react';
import { TextInput } from '@wix/cli-ui-kit';
import type { ActionSchema } from '@wix/cli-app-definitions';
import {
  composeValidations,
  useValidation,
  uuidValidation,
} from '../../../../dev-center/components/validations/index.js';
import { useWixCliAstroBi } from '../../../../bi/index.js';

export const OpenModal: FC<{
  onActionSelected: (action: ActionSchema) => void;
}> = ({ onActionSelected }) => {
  const bi = useWixCliAstroBi();
  const [componentId, setComponentId] = useState<string>();

  const validateComponentId = useValidation(
    composeValidations([
      [uuidValidation, 'Modal id has to be in the format of a uuid'],
    ])
  );

  useEffect(() => {
    if (componentId) {
      onActionSelected({
        openModal: {
          componentId,
        },
      });
    }
  }, [componentId, onActionSelected]);

  return (
    <TextInput
      label={'What is the unique id of the modal?'}
      onSubmit={(componentId) => {
        bi.cliFlowStepAnswered({
          question: 'What is the unique id of the modal?',
          questionKey:
            'generate_command.dashboard_menu_plugin.what_to_do.navigate_to_page.choose_page.other.choose_page_id',
          answer: componentId,
        });
        setComponentId(componentId);
      }}
      validate={validateComponentId}
    />
  );
};
